import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Button,
    CircularProgress,
    Alert,
    IconButton
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { userRequest } from '../../requestMethods';
import VideoPostViewer from './VideoPostViewer';

const VideoPostView = ({ videoPostId }) => {
    const navigate = useNavigate();
    
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (videoPostId) {
            fetchVideoPost();
        }
    }, [videoPostId]);

    const fetchVideoPost = async () => {
        setLoading(true);
        setError(null);
        
        try {
            // Fetch video post data
            const postResponse = await userRequest.get(`/contentVideoPost/${videoPostId}`);
            
            if (!postResponse?.data) {
                throw new Error('Video post not found');
            }
            
            setPost(postResponse.data);
            console.log(`📹 Video post "${postResponse.data.title}" loaded`);
            
        } catch (error) {
            console.error('Error fetching video post:', error);
            
            if (error.response?.status === 404) {
                setError('Video post not found.');
            } else if (error.response?.status === 403) {
                setError('You do not have permission to view this video post.');
            } else {
                setError('Failed to load video post. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleGoBack = () => {
        navigate('/video-posts');
    };

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box>
                <Box display="flex" alignItems="center" gap={2} mb={2}>
                    <IconButton onClick={() => navigate(-1)}>
                        <ArrowBack />
                    </IconButton>
                </Box>
                <Alert severity="error" sx={{ mb: 3 }}>
                    {error}
                </Alert>
                <Button variant="contained" onClick={fetchVideoPost}>
                    Try Again
                </Button>
            </Box>
        );
    }

    if (!post) {
        return (
            <Box>
                <Box display="flex" alignItems="center" gap={2} mb={2}>
                    <IconButton onClick={() => navigate(-1)}>
                        <ArrowBack />
                    </IconButton>
                </Box>
                <Alert severity="warning">
                    Video post not found.
                </Alert>
            </Box>
        );
    }

    return (
        <Box sx={{ mb: 3 }}>
            {/* Back Button */}
            <Box display="flex" alignItems="center" gap={2} mb={2}>
                <IconButton onClick={() => navigate(-1)}>
                    <ArrowBack />
                </IconButton>
            </Box>

            {/* Video Post Viewer */}
            <VideoPostViewer 
                post={post}
            />
        </Box>
    );
};

export default VideoPostView; 